import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "./firebase-config";
import Home from "./pages/Home";
import CreatePost from "./pages/CreatePost";
import Login from "./pages/Login";
import Footer from "./pages/Footer";
import Header from "./pages/Header";
import Certifications from "./pages/Certifications";
import Achievements from "./pages/Achievements";
import Superbadges from "./pages/Superbadges";
// import Blog from "./pages/Blog";
import UseCases from "./pages/useCases"
import UseCaseDetail from "./pages/useCaseDetail"
import About from "./pages/About";
import Contact from "./pages/Contact";
import FlowDetail from "./pages/FlowDetail";
import FlowDocLoader from "./component/FlowDocLoader";
// import AddDriverToHousehold from "./pages/flows/AddDriverToHousehold";
// import CreateDriverLicense from "./pages/flows/CreateDriverLicense";
// import AssignPetToVisit from './pages/flows/AssignPetToVisit'

function App() {
  const [isAuth, setIsAuth] = useState(localStorage.getItem("isAuth"));

  const signUserOut = () => {
    signOut(auth).then(() => {
      localStorage.clear();
      setIsAuth(false);
      window.location.pathname = "/login";
    });
  };

  return (
    <Router>
      <div className="App">
        <Header />
        {/* <nav> */}
          {/* <Link to="/"> Home </Link> */}

          {/* moved login from Nav app to Footer */}
          {/* {!isAuth ? (
            <Link to="/login"> Login </Link>
          ) : (
            <>
              <Link to="/createpost"> Create Post </Link>
              <button onClick={signUserOut}> Log Out</button>
            </>
          )} */}
        {/* </nav> */}
        <main>
          <Routes>
            <Route path="/" element={<Home isAuth={isAuth} />} />
            <Route path="/createpost" element={<CreatePost isAuth={isAuth} />} />
            <Route path="/login" element={<Login setIsAuth={setIsAuth} />} />
            <Route path="/Achievements" element={<Achievements />} />
            <Route path="/Superbadges" element={<Superbadges />} />
            <Route path="/Certifications" element={<Certifications />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/blog" element={<Blog />} /> */}
            {/* All use cases */}
            <Route path="/useCases" element={<UseCases />} />
            {/* Dynamic use case pages */}
            <Route path="/useCases/:useCaseId" element={<UseCaseDetail />} />
            {/* One route for ALL static Flow documentation pages */}
            <Route
              path="/useCases/flows/:flowName"
              element={<FlowDocLoader />}
            />
            <Route 
              path="/useCases/:useCaseId/flows/:flowId" 
              element={<FlowDetail />}
            />
            {/* <Route
              path="/useCases/flows/AddDriverToHousehold"
              element={<AddDriverToHousehold />}
            />
            <Route
              path="/useCases/flows/AssignPetToVisit"
              element={<AssignPetToVisit />}
            />
            <Route
              path="/useCases/flows/CreateDriverLicense"
              element={<CreateDriverLicense />}
            /> */}
          </Routes>
        </main>
        <Footer isAuth={isAuth} setIsAuth={setIsAuth} />
      </div>
    </Router>

  );
}

export default App;